
export const ethereum = {
  chainId: `0x${(1).toString(16)}`,
  chainName: "Ethereum",
  nativeCurrency: {
    name: "ETH",
    symbol: "ETH",
    decimals: 18,
  },
  rpcUrls: ["https://eth.llamarpc.com/"],
  blockExplorerUrls: ["https://etherscan.io/"],
};

export const arbitrum = {
  chainId: `0x${(42161).toString(16)}`,
  chainName: "Arbitrum",
  nativeCurrency: {
    name: "ETH",
    symbol: "ETH",
    decimals: 18,
  },
  rpcUrls: ["https://arb1.arbitrum.io/rpc"],
  blockExplorerUrls: ["https://arbiscan.io/"],
};

export const polygon = {
  chainId: `0x${(137).toString(16)}`,
  chainName: "Polygon",
  nativeCurrency: {
    name: "MATIC",
    symbol: "MATIC",
    decimals: 18,
  },
  rpcUrls: ["https://polygon.llamarpc.com"],
  blockExplorerUrls: ["https://polygonscan.com/"],
};


export const binance = {
  chainId: `0x${(56).toString(16)}`,
  chainName: "Binance",
  nativeCurrency: {
    name: "BNB",
    symbol: "BNB",
    decimals: 18,
  },
  rpcUrls: ["https://bsc-dataseed.binance.org"],
  blockExplorerUrls: ["https://bscscan.com/"],
};

export const avalanche = {
  chainId: `0x${(43114).toString(16)}`,
  chainName: "Avalanche",
  nativeCurrency: {
    name: "AVAX",
    symbol: "AVAX",
    decimals: 18,
  },
  rpcUrls: ["https://api.avax.network/ext/bc/C/rpc"],
  blockExplorerUrls: ["https://snowtrace.io"],
};

export const base = {
  chainId: `0x${(8453).toString(16)}`,
  chainName: "Base",
  nativeCurrency: {
    name: "ETH",
    symbol: "ETH",
    decimals: 18,
  },
  rpcUrls: ["https://base.llamarpc.com"],
  blockExplorerUrls: ["https://basescan.org/"],
};

export const berachain = {
  chainId: `0x${(80094).toString(16)}`,
  chainName: "Berachain",
  nativeCurrency: {
    name: "BERA",
    symbol: "BERA",
    decimals: 18,
  },
  rpcUrls: ["https://rpc.berachain.com"],
  blockExplorerUrls: ["https://berascan.com/"],
};

export const neurochain = {
  chainId: `0x${(313).toString(16)}`,
  chainName: "Neurochain",
  nativeCurrency: {
    name: "NCN",
    symbol: "NCN",
    decimals: 18,
  },
  rpcUrls: ["https://nc-rpc-prd1.neurochain.io"],
  blockExplorerUrls: ["https://ncnscan.com/"],
};


